import { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import L from "leaflet";
import { useMap } from "react-leaflet";

const ControlContainer = ({ position, className, children }) => {
    const map = useMap();
    const containerRef = useRef(document.createElement("div"));
    const controlRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        // Prevent click propagation to map
        L.DomEvent.disableClickPropagation(container);
        L.DomEvent.disableScrollPropagation(container);

        controlRef.current = L.control({ position: position || 'topright' });
        controlRef.current.onAdd = () => container;
        controlRef.current.addTo(map);

        return () => {
            if (controlRef.current) {
                controlRef.current.remove();
            }
        };
    }, [map, position]);

    useEffect(() => {
        const baseClass = "leaflet-control";
        containerRef.current.className = className ? `${baseClass} ${className}` : baseClass;
    }, [className]);

    return ReactDOM.createPortal(children, containerRef.current);
};

export default ControlContainer;
